var React = require('react');

function DiamondPurple (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M35.0651 0H6.93652L15.5 36L35.0651 0Z","fill":"#A17FEB","key":0}),React.createElement("path",{"d":"M0 15.522L6.93575 0L15.5 36L0 15.522Z","fill":"#DDCDFF","key":1}),React.createElement("path",{"d":"M35.0638 0L15.5 36H31.5L35.0638 0Z","fill":"#714CC0","key":2})]);
}

DiamondPurple.defaultProps = {"width":"36","height":"36","viewBox":"0 0 36 36","fill":"none"};

module.exports = DiamondPurple;

DiamondPurple.default = DiamondPurple;
